import clsx from "clsx";
import { INavLinks } from "components/HeaderNavBar/type";
import React from "react";
import * as styles from "./SubFooterNav.module.scss";
import { Trans } from "@lingui/react/macro";

type Props = {
  links: INavLinks;
  className?: string;
};

export const SubFooterNav: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  links
}) => {
  return (
    <div className={clsx(styles.subFooterNav, className)}>
      <ul>
        {links.map((l) => (
          <li key={l.href}>
            <a href={l.href}>{l.title}</a>
          </li>
        ))}
        <li>
          <button
            id="ot-sdk-btn"
            className={`${styles.onetrustButton} ot-sdk-show-settings`}
            suppressHydrationWarning={true}
          >
            <Trans>Cookie Settings</Trans>
          </button>
        </li>
      </ul>
    </div>
  );
};
